const fbq = (...args) => {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq(...args)
  }
}

const gtag = (...args) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag(...args)
  }
}

export const trackPageView = () => {
  fbq("track", "PageView")
}

export const trackViewContent = ({ id, name, category, price, currency }) => {
  fbq("track", "ViewContent", {
    content_ids: [id],
    content_name: name,
    content_category: category,
    content_type: "product",
    value: price,
    currency,
  })
  gtag("event", "view_item", {
    currency,
    value: price,
    items: [{ item_id: id, item_name: name, item_category: category, price }],
  })
}

export const trackAddToCart = ({ id, name, price, quantity, currency }) => {
  const value = price * quantity
  fbq("track", "AddToCart", {
    content_ids: [id],
    content_name: name,
    content_type: "product",
    value,
    currency,
  })
  gtag("event", "add_to_cart", {
    currency,
    value,
    items: [{ item_id: id, item_name: name, price, quantity }],
  })
}

export const trackInitiateCheckout = ({ value, currency, numItems }) => {
  fbq("track", "InitiateCheckout", {
    value,
    currency,
    num_items: numItems,
  })
  gtag("event", "begin_checkout", {
    currency,
    value,
  })
}
